<template>
    <div id="session-handler">
        <login-idle
            :time-remaining="timeRemaining"
            :show="showLoginIdle"
            v-on:continue="pingLogin">
        </login-idle>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        lastPingTime: 0,
        elapsedTime: 0,
        warningTime: 60,
        sessionLifeTime: 25 * 60 // 25 minutes
      };
    },

    computed: {
      timeRemaining: function () {
        var timeRemaining = this.sessionLifeTime - this.elapsedTime;

        return timeRemaining > 0 ? timeRemaining : 0;
      },

      showLoginIdle: function () {
        return this.timeRemaining < this.warningTime;
      }
    },
    methods: {
      pingLogin: function (callback) {
        var vm = this;

        axios.get(window.Portal.pingLoginUrl)
        .then(function (response) {
          if (response.data.success) {
            vm.lastPingTime = vm.getCurrentTimestamp();
            if (typeof callback !== 'undefined') {
              callback();
            }
          } else {
            window.location = window.Portal.loginUrl;
          }
        })
        .catch(function () {
          window.location = window.Portal.loginUrl;
        });
      },

      logout: function () {
        window.location = window.Portal.logoutUrl;
      },

      getCurrentTimestamp: function () {
        return Math.floor(Date.now() / 1000);
      },

      checkTimeRemaining: function () {
        this.elapsedTime = this.getCurrentTimestamp() - this.lastPingTime;

        if (this.timeRemaining <= 0) {
          this.logout();
        }

        setTimeout(this.checkTimeRemaining, 1000);
      }
    },
    created: function () {
      this.lastPingTime = this.getCurrentTimestamp();
      setTimeout(this.checkTimeRemaining, 1000);
    },

    mounted () {
      Vue.http.interceptors.push((request, next) => {
        if (request.url !== window.Portal.pingLoginUrl && !window.Portal.isAdmin) {
          this.pingLogin(next);
        } else {
          next();
        }
      });
    }
  };

  // if (!window.Portal.isAdmin && document.querySelector('#session-handler') !== null) {
  //     sessionHandler.$mount('#session-handler');
  // }

</script>
